var packageName = "@atlassian/switcher";
var packageVersion = "37.0.0";
export default {
  packageName: packageName,
  packageVersion: packageVersion
};